import { useMutation } from "@tanstack/react-query";
import { validateDotdigitalCredentials } from "../../api/bDotdigitalApi";

export const useValidateDotdigital = () => {
  return useMutation({
    mutationKey: ["validate-dotdigital"],
    mutationFn: (data) => validateDotdigitalCredentials(data),
    onError: (error) => {
      console.error("Dotdigital validation error:", error.response || error);
    },
  });
};
